import { getElementById, attachEventToElements, AppHooksType, preloadImg } from './utils';

export function init(appHooks: AppHooksType) {
    const mainFeatureImg = getElementById('main-feature-img') as HTMLImageElement;
    const figureHint = getElementById('figure-hint') as HTMLDivElement;

    attachEventToElements($('ol#main-features > li'), 'mouseover', function (event: MouseEvent) {
        const elem = event.currentTarget as HTMLElement;
        if (elem && elem.tagName === 'LI') {
            const span = $('span', elem)[0];
            const featureText = span.innerText.trim();
            const id = elem.dataset['id'];
            mainFeatureImg.src = `images/main-feature${id}.png`;
            figureHint.innerText = `Figure ${id} (${featureText})`;
        }
    });

    appHooks.onwebp = onwebp;
}

function onwebp() {
    var imagesToPreload = {};
    for (let i = 1; i <= 3; i++) {
        imagesToPreload[`_figure${i}`] = `main-feature${i}.png`;
    }

    /* var imagesToPreload = {
        '_figure1': 'figure1.png',
        '_figure2': 'figure2.png',
        '_figure3': 'figure3.png'
    }; */

    Modernizr.on('webp', function (supported) {
        for (var imgId in imagesToPreload) {
            if (imagesToPreload.hasOwnProperty(imgId)) {
                var imageFile = imagesToPreload[imgId];
                supported = false;
                preloadImg(imageFile, supported, imgId);
            }
        }
    });
}